import { ContentAPI } from 'publication-types'
import { httpGet } from 'common/helpers/http'
import { validateKeyTypes } from 'common/helpers/validation'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { DataLoaderGlobalParams } from 'common/data/resources'

export const validate = (value: any): ContentAPI.RecommendationV4ResponseDTO => {
    const errors = validateKeyTypes('recommend', value, {
        shortform: ['string'],
        longform: ['string'],
        related: [{}],
    })

    if (errors) {
        throw new Error('Recommend response invalid\n    ' + errors.join('    \n'))
    }

    return value
}

export interface Options {
    publicationId: string
    includePremium?: boolean
}

export const getRecommendations = (services: DataLoaderGlobalParams, options: Options) => {
    const include_premium =
        // option defaults to true, which is then confirmed/denied by the feature toggle
        // see commments in https://bitbucket.swmdigital.io/projects/PROD/repos/web/pull-requests/1501/overview
        options.includePremium !== false &&
        isFeatureEnabled(services.store.getState().toggles, 'digital-subscriptions', false)

    return httpGet({
        log: services.log,
        validate,
        baseUrl: services.config.contentApi,
        path: `v4/publication/${options.publicationId}/recommend-video`,
        customHeaders: {
            caller: services.config.apiCallerHeader,
        },
        query: {
            include_premium: include_premium || undefined,
        },
    })
}
